module.exports = __webpack_public_path__ + "static/media/bolt_326.c7f04060.png";